"use client";

import { useState } from "react";
import { useSession, signOut } from "next-auth/react";
import { LoginModal } from "@/components/auth/LoginModal";

export function useAuth() {
  const { data: session, status } = useSession();
  const [showLoginModal, setShowLoginModal] = useState(false);

  const isLoading = status === "loading";
  const isAuthenticated = status === "authenticated";

  const openLoginModal = () => setShowLoginModal(true);
  const closeLoginModal = () => setShowLoginModal(false);

  const handleSignOut = () => signOut({ callbackUrl: "/" });
  // add here also logout button
  return {
    session,
    isLoading,
    isAuthenticated,
    showLoginModal,
    openLoginModal,
    closeLoginModal,
    signOut: handleSignOut,
    LoginModalComponent: (
      <LoginModal open={showLoginModal} onOpenChange={setShowLoginModal} />
    ),
  };
}
